// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-light: rgba(255, 255, 255, 1);
    --primary-light-08: rgba(255, 255, 255, 0.8);
    --primary-light-055: rgba(255, 255, 255, 0.55);
    --primary-light-06: rgba(255, 255, 255, 0.6);
    --primary-light-05: rgba(255, 255, 255, 0.5);
    --primary-light-04: rgba(255, 255, 255, 0.4);
    --primary-light-02: rgba(255, 255, 255, 0.2);
    --primary-light-01: rgba(255, 255, 255, 0.1);
    --primary-light-0: rgba(255, 255, 255, 0);

    --primary-dark: rgba(17, 16, 24, 1);
    --primary-dark-08: rgba(17, 16, 24, 0.8);
    --primary-dark-055: rgba(17, 16, 24, 0.55);
    --primary-dark-06: rgba(17, 16, 24, 0.6);
    --primary-dark-05: rgba(17, 16, 24, 0.5);
    --primary-dark-04: rgba(17, 16, 24, 0.4);
    --primary-dark-02: rgba(17, 16, 24, 0.2);
    --primary-dark-01: rgba(17, 16, 24, 0.1);

    --primary-accent: rgba(151, 198, 186, 1);
    --primary-accent-08: rgba(151, 198, 186, 0.8);
    --primary-accent-055: rgba(151, 198, 186, 0.55);
    --primary-accent-06: rgba(151, 198, 186, 0.6);
    --primary-accent-05: rgba(151, 198, 186, 0.5);
    --primary-accent-04: rgba(151, 198, 186, 0.4);
    --primary-accent-02: rgba(151, 198, 186, 0.2);
    --primary-accent-01: rgba(151, 198, 186, 0.1);

    --secondary-accent: rgba(152, 123, 250, 1);
    --secondary-accent-08: rgba(152, 123, 250, 0.8);
    --secondary-accent-055: rgba(152, 123, 250, 0.55);
    --secondary-accent-06: rgba(152, 123, 250, 0.6);
    --secondary-accent-05: rgba(152, 123, 250, 0.5);
    --secondary-accent-04: rgba(152, 123, 250, 0.4);
    --secondary-accent-02: rgba(152, 123, 250, 0.2);
    --secondary-accent-01: rgba(152, 123, 250, 0.1);
}

body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    max-height: var(--vh);
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

#info-window {
    display: flex;
    align-items: center;
    gap: 20px;
    overflow: visible !important;
}

#info-window .place-info {
    background-color: var(--primary-dark);
    color: var(--primary-light);
    width: 250px;
    padding: 10px 10px;
    border-radius: 30px;
}

#info-window > .place-info > .info-window-image {
    width: 100%;
    height: 150px;
    border-radius: 20px;
}

#info-window > .place-info > .info-window-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 12px;
    line-height: 1.5;
}

#info-window > .place-info > .info-window-content > h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
}

#info-window > .place-name {
    align-content: center;
    height: 20px;
    background-color: rgba(28, 28, 28, 0.9);
    display: block;
    border-radius: 32px;
    padding: 6px 12px 2px 12px;
}

#info-window > .place-name > span {
    font-size: 13px;
    text-transform: capitalize;
    font-weight: normal;
    color: #f8d648;
    border-radius: 32px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    text-align: center;
}

.gm-style-iw {
    padding: 0 !important;
    background-color: transparent !important;
    box-shadow: none !important;
    overflow: visible !important;
    margin: 0;

    margin: 0;
    z-index: 100000;
    pointer-events: none;
}

.gm-style-iw-d {
    width: 100%;
    margin-left: 50%;
    transform: translateY(50%);
}

.gm-style-iw-tc,
.gm-ui-hover-effect {
    display: none !important;
}

.gmnoprint a,
.gmnoprint span {
    display: none;
}
.gmnoprint div {
    background: none !important;
    display: none;
}

img[src="http://maps.gstatic.com/mapfiles/api-3/images/google_white2.png"], a[href^="https://maps.google.com/maps?ll=27.735471,-91.052683&z=3&hl=en&gl=US&mapclient=apiv3"]
{
    display: none !important;
}

img[src="http://maps.gstatic.com/mapfiles/api-3/images/google_white2.png"], a[href^="https://www.google.com/maps?ll=0,0&z=4&hl=en&gl=US&mapclient=apiv3"]
{
    display: none !important;
}

img[alt='Google'] {
    display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,4CAA4C;IAC5C,8CAA8C;IAC9C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,yCAAyC;;IAEzC,mCAAmC;IACnC,wCAAwC;IACxC,0CAA0C;IAC1C,wCAAwC;IACxC,wCAAwC;IACxC,wCAAwC;IACxC,wCAAwC;IACxC,wCAAwC;;IAExC,wCAAwC;IACxC,6CAA6C;IAC7C,+CAA+C;IAC/C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;;IAE7C,0CAA0C;IAC1C,+CAA+C;IAC/C,iDAAiD;IACjD,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;AACnD;;AAEA;IACI,SAAS;IACT;kBACc;IACd,mCAAmC;IACnC,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,uCAAuC;IACvC,cAAc;IACd,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,wCAAwC;IACxC,2BAA2B;IAC3B,4BAA4B;IAC5B,SAAS;;IAET,SAAS;IACT,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;IAEI,aAAa;AACjB;AACA;IACI,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[":root {\n    --primary-light: rgba(255, 255, 255, 1);\n    --primary-light-08: rgba(255, 255, 255, 0.8);\n    --primary-light-055: rgba(255, 255, 255, 0.55);\n    --primary-light-06: rgba(255, 255, 255, 0.6);\n    --primary-light-05: rgba(255, 255, 255, 0.5);\n    --primary-light-04: rgba(255, 255, 255, 0.4);\n    --primary-light-02: rgba(255, 255, 255, 0.2);\n    --primary-light-01: rgba(255, 255, 255, 0.1);\n    --primary-light-0: rgba(255, 255, 255, 0);\n\n    --primary-dark: rgba(17, 16, 24, 1);\n    --primary-dark-08: rgba(17, 16, 24, 0.8);\n    --primary-dark-055: rgba(17, 16, 24, 0.55);\n    --primary-dark-06: rgba(17, 16, 24, 0.6);\n    --primary-dark-05: rgba(17, 16, 24, 0.5);\n    --primary-dark-04: rgba(17, 16, 24, 0.4);\n    --primary-dark-02: rgba(17, 16, 24, 0.2);\n    --primary-dark-01: rgba(17, 16, 24, 0.1);\n\n    --primary-accent: rgba(151, 198, 186, 1);\n    --primary-accent-08: rgba(151, 198, 186, 0.8);\n    --primary-accent-055: rgba(151, 198, 186, 0.55);\n    --primary-accent-06: rgba(151, 198, 186, 0.6);\n    --primary-accent-05: rgba(151, 198, 186, 0.5);\n    --primary-accent-04: rgba(151, 198, 186, 0.4);\n    --primary-accent-02: rgba(151, 198, 186, 0.2);\n    --primary-accent-01: rgba(151, 198, 186, 0.1);\n\n    --secondary-accent: rgba(152, 123, 250, 1);\n    --secondary-accent-08: rgba(152, 123, 250, 0.8);\n    --secondary-accent-055: rgba(152, 123, 250, 0.55);\n    --secondary-accent-06: rgba(152, 123, 250, 0.6);\n    --secondary-accent-05: rgba(152, 123, 250, 0.5);\n    --secondary-accent-04: rgba(152, 123, 250, 0.4);\n    --secondary-accent-02: rgba(152, 123, 250, 0.2);\n    --secondary-accent-01: rgba(152, 123, 250, 0.1);\n}\n\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n        sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    max-height: var(--vh);\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n#info-window {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    overflow: visible !important;\n}\n\n#info-window .place-info {\n    background-color: var(--primary-dark);\n    color: var(--primary-light);\n    width: 250px;\n    padding: 10px 10px;\n    border-radius: 30px;\n}\n\n#info-window > .place-info > .info-window-image {\n    width: 100%;\n    height: 150px;\n    border-radius: 20px;\n}\n\n#info-window > .place-info > .info-window-content {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 12px;\n    line-height: 1.5;\n}\n\n#info-window > .place-info > .info-window-content > h3 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n#info-window > .place-name {\n    align-content: center;\n    height: 20px;\n    background-color: rgba(28, 28, 28, 0.9);\n    display: block;\n    border-radius: 32px;\n    padding: 6px 12px 2px 12px;\n}\n\n#info-window > .place-name > span {\n    font-size: 13px;\n    text-transform: capitalize;\n    font-weight: normal;\n    color: #f8d648;\n    border-radius: 32px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    text-align: center;\n}\n\n.gm-style-iw {\n    padding: 0 !important;\n    background-color: transparent !important;\n    box-shadow: none !important;\n    overflow: visible !important;\n    margin: 0;\n\n    margin: 0;\n    z-index: 100000;\n    pointer-events: none;\n}\n\n.gm-style-iw-d {\n    width: 100%;\n    margin-left: 50%;\n    transform: translateY(50%);\n}\n\n.gm-style-iw-tc,\n.gm-ui-hover-effect {\n    display: none !important;\n}\n\n.gmnoprint a,\n.gmnoprint span {\n    display: none;\n}\n.gmnoprint div {\n    background: none !important;\n    display: none;\n}\n\nimg[src=\"http://maps.gstatic.com/mapfiles/api-3/images/google_white2.png\"], a[href^=\"https://maps.google.com/maps?ll=27.735471,-91.052683&z=3&hl=en&gl=US&mapclient=apiv3\"]\n{\n    display: none !important;\n}\n\nimg[src=\"http://maps.gstatic.com/mapfiles/api-3/images/google_white2.png\"], a[href^=\"https://www.google.com/maps?ll=0,0&z=4&hl=en&gl=US&mapclient=apiv3\"]\n{\n    display: none !important;\n}\n\nimg[alt='Google'] {\n    display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
